document.addEventListener('DOMContentLoaded', function () {
  if (typeof gtag !== 'function') return;

  const trackedGenerators = document.querySelectorAll('[data-generator-name]');

  trackedGenerators.forEach(function (generator) {
    const generatorName = generator.dataset.generatorName || 'Unknown Generator';
    const accessType = generator.dataset.generatorAccess || 'unknown';
    const category = generator.dataset.generatorCategory || 'generator';

    let useTracked = false;

    function trackEvent(eventName, extraData = {}) {
      if (typeof gtag !== 'function') return;

      gtag('event', eventName, {
        generator_name: generatorName,
        access_type: accessType,
        generator_category: category,
        ...extraData
      });
    }

    trackEvent('generator_view');

    const useButtons = generator.querySelectorAll('[data-track="use"]');
    useButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!useTracked) {
          trackEvent('generator_use', { trigger: 'button_click' });
          useTracked = true;
        }
      });
    });

    const downloadButtons = generator.querySelectorAll('[data-track="download"]');
    downloadButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        trackEvent('generator_download', {
          file_type: btn.dataset.fileType || 'svg'
        });
      });
    });

    const unlockButtons = generator.querySelectorAll('[data-track="unlock"]');
    unlockButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        trackEvent('generator_unlock_click');
      });
    });

    const inputs = generator.querySelectorAll('input, textarea, select');
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!useTracked) {
          trackEvent('generator_use', {
            trigger: 'input_change'
          });
          useTracked = true;
        }
      });
    });
  });
});